import React, { useState, useEffect } from "react";
import Main from "../../components/template/Main";
import { useParams,useHistory } from "react-router-dom";
import { post,get,put } from "../../store/config/register";
import { toast } from "react-toastify";

const headerProps = {
    icon: "tasks",
    title: "Tarefa",
    subtitle: "Cadastro"
}

const initialState ={
    tarefa: {
      id: 0,
      idAtividade: 0,
      qFazer: '',
      comoFazer: '',
      executado: false,
    }
  }

  function  handleKeyDown(e) {
    e.target.style.height = 'inherit';
    e.target.style.height = `${e.target.scrollHeight}px`; 
  }

export default function Tarefa(){
    const { id,idTarefa } = useParams();
    const [tarefa,setTarefa] = useState(initialState.tarefa);
    const history = useHistory();


    function  updateField( event){
        const tare ={...tarefa}
        tare[event.target.name] = event.target.value
        setTarefa(tare);
    }

     useEffect(()=>{
        setTarefa({...tarefa, idAtividade: parseInt(id)});
        if(idTarefa !== undefined){
            buscaDados(idTarefa);
        }

      },[]);

      async function buscaDados(IdTarefa) {
       const tare = await get(`/Tarefa/v1/Atividade?IdAtividade=${id}&IdTarefa=${IdTarefa}`);
       if(tare !== undefined){
        setTarefa(tare);
       }
      }

 async function Salvar(){
        if(Validar()){
            if(idTarefa === undefined){
                const res =  await post('/Tarefa/v1',tarefa);
            }else {
                const res =  await put(`/Tarefa/v1/${idTarefa}`,tarefa);
            }
         
            toast.success('tarefa salva com sucesso.')
            history.goBack()

        }
    }

      function Validar(){

        if(tarefa.qFazer === ''){
            toast.warning('Digite qual a tarefa');
            return false;
        }
        if(tarefa.comoFazer === ''){
            toast.warning('Descreva a tarefa');
            return false;
        }

        return true;
    }
    

    function renderForm(){
        return(
            <div className="form">
                <div className="email">
                    <div className="form-group">
                    <label>Título:</label>
                    <input type="text" name="qFazer" 
                    placeholder="Titulo"
                        className="form-control" value={tarefa.qFazer} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>
                <div className="email">
                    <div className="form-group">
                    <label>Descrição:</label>
                    <textarea  rows="1" type="text" name="comoFazer" placeholder="Descrição" onKeyDown={handleKeyDown}
                        className="form-control auto_height" value={tarefa.comoFazer} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>
                    <div id="botao">
                    <button  className="btn btn-primary ml-2" onClick={ async e => await Salvar()}>
                        Salvar
                    </button>
                    <button className="btn btn-secondary ml-2" onClick={e => history.goBack()}>
                        Cancelar
                    </button>
                </div>       
            </div>
        );
    }

    return (
        <Main {...headerProps}> 
           {renderForm()}
        </Main>
    );
}